// import Bar from './BaseCharts/Bar'
// import Doughnut from './BaseCharts/Doughnut'
// import Line from './BaseCharts/Line'
// import Pie from './BaseCharts/Pie'
// import PolarArea from './BaseCharts/PolarArea'
// import Radar from './BaseCharts/Radar'
// import Bubble from './BaseCharts/Bubble'
// import reactiveProp from './mixins/reactiveProp'
// import reactiveData from './mixins/reactiveData'

// const VueCharts = {
//   Bar,
//   Doughnut,
//   Line,
//   Pie,
//   PolarArea,
//   Radar,
//   Bubble,
//   reactiveProp,
//   reactiveData
// }

// module.exports = VueCharts

import Vue from 'vue'
import App from './examples/App'

/* eslint-disable no-new */

new Vue({
  components: { App }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/index.js